'use client';

import { c as _c } from "react/compiler-runtime";
import { memo, Suspense } from 'react';
import ConsumerNewsletter from 'components/consumer/ConsumerNewsletter';
import ConsumerNewFooter from 'components/consumer/consumer-new-footer';
const PageFooterForLayout = t0 => {
  const $ = _c(4);
  const {
    layoutName
  } = t0;
  let t1;
  if ($[0] !== layoutName) {
    t1 = ["Default", "NewLayout", "ConsumerWithoutHeader", "NewSubMenuLayout"].includes(layoutName) && <><Suspense fallback={null}><ConsumerNewsletter /></Suspense><Suspense fallback={null}><ConsumerNewFooter /></Suspense></>;
    $[0] = layoutName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <>{t1}</>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default memo(PageFooterForLayout);